// Postcard image sharing — copy the composed image to the clipboard as a real
// photo. WhatsApp link previews degrade in broadcasts, so distributing the
// image itself is the fix.

// Safari's clipboard only reliably accepts image/png via ClipboardItem, so ask
// Cloudinary for a PNG (f_png) rather than converting client-side.
export const pngClipboardUrl = (url) => {
  if (!url) return url;
  const marker = '/image/upload/';
  if (url.includes('res.cloudinary.com') && url.includes(marker)) {
    const [head, tail] = url.split(marker);
    return `${head}${marker}f_png/${tail}`;
  }
  return url;
};

// Copy the composed postcard image to the clipboard. Uses the promise-based
// ClipboardItem so Safari accepts it inside the click handler (no await before
// clipboard.write, or the user-gesture is lost). Throws on failure.
export const copyPostcardImage = async (postcard) => {
  const url = pngClipboardUrl(postcard?.composed_image_url);
  if (!url) throw new Error('No composed image to copy');
  await navigator.clipboard.write([
    new ClipboardItem({
      'image/png': fetch(url).then((r) => {
        if (!r.ok) throw new Error('Image fetch failed');
        return r.blob();
      }),
    }),
  ]);
};
